import { sha256 } from '@noble/hashes/sha256';
import { Buffer } from '@stacks/common';
import { decode, encode, encodingLength } from 'varuint-bitcoin';
const chainPrefix = '\x18Stacks Message Signing:\n';
export function hashMessage(message) {
    return Buffer.from(sha256(encodeMessage(message)));
}
export function encodeMessage(message) {
    const encoded = encode(Buffer.from(message).length);
    return Buffer.concat([Buffer.from(chainPrefix), encoded, Buffer.from(message)]);
}
export function decodeMessage(encodedMessage) {
    const messageWithoutChainPrefix = encodedMessage.subarray(1 + 24);
    const decoded = decode(messageWithoutChainPrefix);
    const varIntLength = encodingLength(decoded);
    return messageWithoutChainPrefix.slice(varIntLength);
}
//# sourceMappingURL=messageSignature.js.map